<template>
    <BCard v-if="discount">
        <BRow>
            <BCol cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="discount.name" />
                    <ViewData vsIcon="UserIcon" vsLabel="Type" :vsValue="discount.type=='percentage' ? 'Porcentaje' : 'Importe'" />
                    <ViewData vsIcon="UserIcon" vsLabel="Value" :vsValue="discount.value" />
                    <ViewData vsIcon="UserIcon" vsLabel="Status" :vsValue="discount.status" vsCheckbox />
                </table>
            </BCol>
            <BCol cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="UserIcon" vsLabel="Start date" :vsValue="discount.start_date" />
                    <ViewData vsIcon="UserIcon" vsLabel="End date" :vsValue="discount.end_date" />
                    <ViewData vsIcon="UserIcon" vsLabel="Aplicado a" :vsValue="$t(discount.item_type)" />
                    <ViewData vsIcon="UserIcon" vsLabel="Item" :vsValue="discount.item.name" v-if="discount.item" />
                </table>
            </BCol>
            <BCol cols="12" class="mt-3">
                <div class="d-flex flex-wrap">
                    <BButton :to="{ name: 'discounts-edit', params: { id: discount.id } }" variant="primary" v-if="ability.can('write', 'discount')"> {{$t('Edit')}} </BButton>
                    <BButton variant="outline-danger" class="ml-1" @click="deletePopup(discount.id, 'discounts/deleteDiscount', 'discounts')" v-if="ability.can('delete', 'discount')"> {{$t('Delete')}} </BButton>
                </div>
            </BCol>
        </BRow>
    </BCard>
</template>

<script>
import { onUnmounted, ref } from '@vue/composition-api';
import { BButton, BCard, BCol, BRow } from 'bootstrap-vue';
import ViewData from '@/components/ViewData.vue';
import discountModule from '../discountModule';
import ability from '@/libs/acl/ability';
import popups from '@/hooks/popups';
import router from '@/router';
import store from '@/store';
import i18n from '@/libs/i18n'

export default {
    components: { BCard, BRow, BCol, ViewData, BButton },
    setup(){
        const { deletePopup }  = popups()
        const DISCOUNT_MODULE = 'discounts'
        const discount = ref(null)

        if(!store.hasModule(DISCOUNT_MODULE)){
            store.registerModule(DISCOUNT_MODULE, discountModule)
        }

        onUnmounted(() => {
            if(store.hasModule(DISCOUNT_MODULE)){
                store.unregisterModule(DISCOUNT_MODULE)
            }
        })

        store.dispatch('discounts/fetchDiscount', { id: router.currentRoute.params.id }).then(response => {
            discount.value = response.data.discount
        })

        return{
            deletePopup,
            ability,
            discount
        }
    }
}
</script>

<style lang="scss">
    @import 'src/assets/scss/variables/_variables.scss';
    table tr th, .title {
        color: $primary;
    }

    table tr th span, .title {
        text-transform: uppercase;
    }

</style>
